'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowPartialRotateLeft, iconArrowPartialRotateLeftTag } from '@ni/nimble-components/dist/esm/icons/arrow-partial-rotate-left';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowPartialRotateLeft };
export { iconArrowPartialRotateLeftTag };
export const NimbleIconArrowPartialRotateLeft = wrap(IconArrowPartialRotateLeft);